<template>
  <v-app>
    <v-app-bar app clipped-left color="white" elevation="1">
      <v-app-bar-nav-icon
        v-show="!showSearch"
        @click="appBarIconDrawerOnClick"
      ></v-app-bar-nav-icon>
      <a href="javascript:void(0)">
        <v-img
          v-show="!showSearch"
          @click="logoClick"
          :src="$userInfo.companies[0].coverImg"
          max-height="50"
          max-width="80"
          contain
        />
      </a>
      <!-- $userInfo.companies[0].coverImg -->

      <!-- <div class="layoutHeader hidden-sm-and-down">NERDOF</div> -->
      <v-btn icon v-show="showSearch" @click="showSearch = false">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-spacer align="center">
        <v-form
          @submit.prevent="onSearch"
          ref="formSearch"
          class="px-5"
          v-show="$vuetify.breakpoint.mdAndUp || showSearch"
        >
          <v-text-field
            class="searchBox"
            placeholder="Type in to search..."
            prepend-inner-icon="far fa-search"
            clearable
            hide-details
            outlined
            dense
            v-model="mainSearch"
            id="searchId"
          ></v-text-field>
        </v-form>
      </v-spacer>

      <v-btn
        v-show="$vuetify.breakpoint.smAndDown && !showSearch"
        icon
        @click="showSearch = true"
        class="show-sm-and-down"
      >
        <v-icon>mdi-magnify</v-icon>
      </v-btn>

      <v-menu offset-y v-if="avatar">
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on">
            <v-avatar size="35" class="mr-3">
              <v-img :src="avatar"></v-img>
            </v-avatar>
            <div class="px-2 text-capitalize hidden-sm-and-down">
              {{ displayName }}
            </div>
            <v-icon class="hidden-sm-and-down">mdi-chevron-down</v-icon>
          </v-btn>
        </template>

        <v-list dense class="list-menu" v-if="avatar">
          <v-list-item link :to="{ name: 'my_course' }">
            <v-list-item-icon>
              <v-icon class="fa-fw">far fa-books</v-icon>
            </v-list-item-icon>
            <v-list-item-title>My Course</v-list-item-title>
          </v-list-item>
          <v-list-item link :to="{ name: 'wishlist' }">
            <v-list-item-icon>
              <v-icon class="fa-fw">far fa-heart</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Wish List</v-list-item-title>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item link :to="{ name: 'profile' }">
            <v-list-item-icon>
              <v-icon class="fa-fw">far fa-address-card</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item>
          <!-- <v-list-item link :to="{ name: 'portfolio' }">
            <v-list-item-icon>
              <v-icon class="fa-fw">far fa-images</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Portfolio</v-list-item-title>
          </v-list-item> -->
          <!-- ยังไม่มี API เรียกลิสต์ทั้งหมด แต่สามารถสร้างโพสต์ได้-->

          <v-list-item link @click="logout">
            <v-list-item-icon>
              <v-icon class="fa-fw">far fa-sign-out</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Sign out</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu offset-y v-else>
        <template v-slot:activator="{ on, attrs }">
          <div v-if="$vuetify.breakpoint.smAndDown">
            <v-btn text v-bind="attrs" v-on="on">
              <v-avatar size="35">
                <v-icon color="black">mdi-account</v-icon>
              </v-avatar>
            </v-btn>
          </div>
          <div v-else>
            <v-btn text :to="{ name: 'login' }">Sign in</v-btn>
            <v-btn text v-if="canRegister" :to="{ name: 'register' }"
              >Register</v-btn
            >
          </div>
        </template>
        <v-list dense class="list-menu">
          <v-list-item link :to="{ name: 'login' }">
            <v-list-item-icon>
              <v-icon class="fa-fw">fas fa-sign-in</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Sign in</v-list-item-title>
          </v-list-item>
          <v-list-item link :to="{ name: 'register' }" v-if="canRegister">
            <v-list-item-icon>
              <v-icon class="fa-fw">fas fa-user-plus</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Register</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- <v-navigation-drawer app clipped v-model="drawer"> -->
    <v-navigation-drawer app :mini-variant="mini" clipped v-model="drawer">
      <div class="mainNavigator">
        <div class="navigatorDiv">
          <!-- <v-list nav dense>
            <v-list-item-group color="primary">
              <v-list-item v-for="(item, i) in menuItems" :key="i">
                <div class="oneLineDiv">
                  <div>
                    <v-icon v-text="item.icon"></v-icon>
                  </div>
                  <div class="navigator-item">{{ item.text }}</div>
                </div>
              </v-list-item>
            </v-list-item-group>
          </v-list> -->
          <v-list nav dense>
            <v-list-item-group
              :color="themeColor"
              v-model="isMenu"
              :mandatory="isMenuActive"
            >
              <template v-for="item in $userInfo.setting">
                <v-list-item
                  :key="item.type"
                  :value="item.type"
                  @click="navigate('menu', item)"
                >
                  <v-list-item-icon>
                    <v-icon v-if="item.icon == 'home'">mdi-home-outline</v-icon>
                    <v-icon v-if="item.icon == 'video'"
                      >mdi-play-box-outline</v-icon
                    >
                    <v-icon v-if="item.icon == 'search'">mdi-magnify</v-icon>
                    <v-icon v-if="item.icon == 'setting'"
                      >mdi-account-outline</v-icon
                    >
                    <v-icon v-if="item.icon == 'notification'"
                      >mdi-bell-outline</v-icon
                    >
                  </v-list-item-icon>

                  <v-list-item-content>
                    <span class="navigator-item">{{ item.name }}</span>
                  </v-list-item-content>
                </v-list-item>
              </template>

              <!-- <v-list-item
                @click="navigate('mycourse', null)"
                key="mycourse"
                value="mycourse"
              >
                <v-list-item-icon>
                  <v-icon>mdi-book-open-variant</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <span class="navigator-item">My Courses</span>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                @click="navigate('profile', null)"
                key="profile"
                value="profile"
              >
                <v-list-item-icon>
                  <v-icon>mdi-school</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <span class="navigator-item">Personal Information</span>
                </v-list-item-content>
              </v-list-item>

              <v-list-item
                @click="navigate('favorite', null)"
                key="favorite"
                value="favorite"
              >
                <v-list-item-icon>
                  <v-icon>mdi-heart</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <span class="navigator-item">Favorite</span>
                </v-list-item-content>
              </v-list-item> -->
            </v-list-item-group>
          </v-list>
        </div>
        <v-divider />

        <!-- category -->
        <div class="navigatorDiv" v-if="listCategory.length">
          <div class="navigatorTitle my-2">Category</div>
          <v-list nav dense>
            <v-list-item-group
              :color="themeColor"
              v-model="isCatgActive"
              :mandatory="isCatgActive"
            >
              <template
                v-if="idx < category.limit_by"
                v-for="(item, idx) in listCategory"
              >
                <v-list-item
                  :key="item._id"
                  :value="item._id"
                  @click="navigate('category', item)"
                >
                  <v-list-item-icon v-if="item.image">
                    <v-avatar size="20">
                      <v-img :src="item.image"></v-img>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <span class="navigator-item">{{ item.title }}</span>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
          <div
            align="center"
            v-if="
              listCategory.length > category.default_limit &&
              category.limit_by === category.default_limit
            "
          >
            <v-btn
              class="mb-3 text-capitalize"
              outlined
              color="#9b9b9b"
              @click="
                simpleToggleShowMore('category', listCategory.length, 'more')
              "
              >Show more</v-btn
            >
          </div>

          <div
            align="center"
            v-if="
              listCategory.length > category.default_limit &&
              category.limit_by != category.default_limit
            "
          >
            <v-btn
              class="mb-3 text-capitalize"
              outlined
              color="#9b9b9b"
              @click="
                simpleToggleShowMore('category', listCategory.length, 'less')
              "
              >Show less</v-btn
            >
          </div>
        </div>
        <v-divider v-if="listCategory.length" />

        <!-- grade -->
        <!-- <div class="navigatorDiv pt-4" v-if="elements.grade">
          <div class="navigatorTitle">{{ elements.grade.title }}</div>
          <v-list nav dense>
            <v-list-item-group color="primary" v-model="isGradeActive">
              <template
                v-if="idx < grade.limit_by"
                v-for="(item, idx) in elements.grade.body"
              >
                <v-list-item :key="idx" @click="navigate('grade', item)">
                  <v-list-item-icon>
                    <v-icon size="12">mdi-circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <span class="navigator-item">{{ item.title }}</span>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
          <div
            align="center"
            v-if="elements.grade.body.length > grade.default_limit"
          >
            <v-btn class="mb-3" outlined color="#9b9b9b"
              ><div
                class="text-capitalize"
                @click="
                  simpleToggleShowMore('grade', elements.grade.body.length)
                "
              >
                {{
                  grade.limit_by === grade.default_limit
                    ? "Show more"
                    : "Show less"
                }}
              </div></v-btn
            >
          </div>
        </div> -->

        <!-- <v-divider /> -->

        <!-- instructors -->
        <div class="navigatorDiv" v-if="listTutor.length">
          <div class="navigatorTitle my-2">Instructor</div>
          <v-list nav dense>
            <v-list-item-group
              :color="themeColor"
              v-model="isTutorActive"
              :mandatory="isTutorActive"
            >
              <template
                v-if="idx < tutor.limit_by"
                v-for="(item, idx) in listTutor"
              >
                <v-list-item
                  :key="item._id"
                  @click="navigate('tutor', item)"
                  :value="item._id"
                >
                  <v-list-item-icon>
                    <v-avatar size="25">
                      <v-img :src="item.image"></v-img>
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <span class="navigator-item">{{ item.displayName }}</span>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-item-group>
          </v-list>
          <div align="center" v-if="listTutor.length > tutor.default_limit">
            <v-btn
              class="mb-3 text-capitalize"
              outlined
              color="#9b9b9b"
              @click="more_tutor()"
            >
              Show more
            </v-btn>
          </div>
        </div>
        <v-divider v-if="listTutor.length" />

        <!-- tag/skill -->
        <div class="navigatorDiv" v-if="listTag.length">
          <div class="navigatorTitle my-2">Tag</div>

          <div class="pa-4">
            <v-chip-group
              :color="themeColor"
              column
              v-model="isTagActive"
              :mandatory="isTagActive"
            >
              <template
                v-if="idx < tag.limit_by"
                v-for="(item, idx) in listTag"
              >
                <v-chip
                  :key="item._id"
                  @click="navigate('tag', item)"
                  :value="item._id"
                >
                  <span class="title-tag">{{ item.title }}</span>
                </v-chip>
              </template>
            </v-chip-group>
          </div>
          <div
            align="center"
            v-if="
              listTag.length > tag.default_limit &&
              tag.limit_by === tag.default_limit
            "
          >
            <v-btn
              class="mb-3 text-capitalize"
              outlined
              color="#9b9b9b"
              @click="simpleToggleShowMore('tag', listTag.length, 'more')"
            >
              Show more
            </v-btn>
          </div>

          <div
            align="center"
            v-if="
              listTag.length > tag.default_limit &&
              tag.limit_by != tag.default_limit
            "
          >
            <v-btn
              class="mb-3 text-capitalize"
              outlined
              color="#9b9b9b"
              @click="simpleToggleShowMore('tag', listTag.length, 'less')"
            >
              Show less
            </v-btn>
          </div>
        </div>
      </div>
    </v-navigation-drawer>

    <v-main style="background-color: #fafafa">
      <v-container fluid :class="isClassRoom">
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Vue from "vue";
import { EventBus } from "@/event-bus";
import { environment } from "../store/environment";
var CryptoJS = require("crypto-js");
import { createLogger } from "vuex";
export default {
  data: () => ({
    isMenuActive: false,
    isCatgActive: false,
    isGradeActive: false,
    isTutorActive: false,
    isTagActive: false,
    drawer: true,
    group: null,
    showSearch: false,
    // elements: {
    //   grade: "",
    //   category: "",
    //   instructor: "",
    //   tag: "",
    // },
    category: {
      default_limit: 4,
      limit_by: 4,
    },
    grade: {
      default_limit: 4,
      limit_by: 4,
    },
    tutor: {
      default_limit: 4,
      limit_by: 4,
    },
    tag: {
      default_limit: 4,
      limit_by: 4,
    },
    // menuItems: [
    //   { text: "Home", icon: "mdi-home" },
    //   { text: "My Courses", icon: "mdi-book-open-variant" },
    //   { text: "Personal Information", icon: "mdi-school" },
    //   { text: "Favorite", icon: "mdi-heart" },
    // ],
    cartCount: 0,
    drawer: false,
    title: "",
    displayName: "",
    avatar: null,
    logo: null,
    contact: "",
    mobileSearch: false,
    mainSearch: "",
    listCategory: [],
    listTag: [],
    listTutor: [],
    themeColor: "primary",
    CatgId: null,
    TagId: null,
    icon: {
      home: "mdi-home-outline",
      search: "mdi-magnify",
      course: "mdi-play-box-outline",
      setting: "mdi-account-outline",
      video: "mdi-play-box-outline",
      book: "mdi-book",
      chat: "mdi-chat-processing",
      info: "mdi-information-outline",
      email: "mdi-email-outline",
      user: "mdi-account-multiple",
      calendar: "mdi-calendar-month",
    },
    isMenu: "home",
    mini: false,
  }),
  methods: {
    async getCategoryList() {
      this.listCategory = [];
      this.query = {
        page: 1,
        limit: 1000,
        sort: "title",
        sortby: 1,
      };
      await this.$http
        .get(
          `${this.$store.state.api}/home/category?page=${this.query.page}&limit=${this.query.limit}&sort=${this.query.sort}&sortby=${this.query.sortby}`
        )
        .then((resp) => {
          if (resp.status == 200 && resp.data.status == true) {
            this.listCategory = resp.data.result.elements;
          }
        })
        .catch((err) => {});
    },
    async getTagList() {
      this.listTag = [];
      this.query = {
        page: 1,
        limit: 1000,
        sort: "title",
        sortby: 1,
      };
      await this.$http
        .get(
          `${this.$store.state.api}/home/skill?page=${this.query.page}&limit=${this.query.limit}&sort=${this.query.sort}&sortby=${this.query.sortby}`
        )
        .then((resp) => {
          if (resp.status == 200 && resp.data.status == true) {
            this.listTag = resp.data.result.elements;
          }
        })
        .catch((err) => {});
    },
    async getTutorList() {
      let token = this.$cookies.get("user_token");
      let company = Vue.prototype.$userInfo.companies[0]._id;
      this.listTutor = [];
      this.query = {
        page: 1,
        limit: 1000,
        sort: "title",
        sortby: 1,
      };
      await this.$http
        .get(
          `${this.$store.state.api}/home/teacher?page=${
            this.query.page
          }&limit=${this.query.limit}&sort=${this.query.sort}&sortby=${
            this.query.sortby
          }${token ? "" : "&companyID=" + company}`
        )
        .then((resp) => {
          if (resp.status == 200 && resp.data.status == true) {
            this.listTutor = resp.data.result.elements;
          }
        })
        .catch((err) => {});
    },
    logoClick() {
      if (this.$route.name != "home") {
        this.$router.push({
          path: "/home",
        });
      }

      this.isMenu = "home";
      this.isMenuActive = true;
      this.isCatgActive = false;
      this.isGradeActive = false;
      this.isTagActive = false;
      this.isTutorActive = false;
    },
    appBarIconDrawerOnClick() {
      this.drawer = !this.drawer;
    },
    // getDataElements(value) {
    //   this.elements.grade = value.grade_horizontal_listview;
    //   this.elements.instructor = value.teacher_horizontal_listview;
    //   this.elements.category = value.category_horizontal_listview;
    //   this.elements.tag = value.tag_list;
    // },
    simpleToggleShowMore(mode, item_length, text) {
      switch (mode) {
        case "category":
          let item_catg = [];
          let idx_catg = "";
          if (text == "less") {
            this.listCategory.forEach((element, idx) => {
              if (element._id == this.CatgId) {
                item_catg = element;
                idx_catg = idx;
              }
            });
            if (idx_catg > 3) {
              this.isCatgActive = false;
            }
          } else if (text == "more") {
            this.listCategory.forEach((element, idx) => {
              if (element._id == this.CatgId) {
                item_catg = element;
                idx_catg = idx;
              }
            });
            if (idx_catg > 3) {
              this.isCatgActive = item_catg._id;
            }
          }

          this.category.limit_by =
            this.category.limit_by === this.category.default_limit
              ? item_length
              : this.category.default_limit;
          this.isMenuActive = false;
          this.isGradeActive = false;
          this.isTagActive = false;
          this.isTutorActive = false;
          break;

        case "grade":
          this.grade.limit_by =
            this.grade.limit_by === this.grade.default_limit
              ? item_length
              : this.grade.default_limit;
          this.isMenuActive = false;
          this.isTagActive = false;
          this.isTutorActive = false;
          this.isCatgActive = false;
          break;

        case "tutor":
          this.tutor.limit_by =
            this.tutor.limit_by === this.tutor.default_limit
              ? item_length
              : this.tutor.default_limit;
          break;

        case "tag":
          let item_tag = [];
          let idx_tag = "";
          if (text == "less") {
            this.listTag.forEach((element, idx) => {
              if (element._id == this.TagId) {
                item_tag = element;
                idx_tag = idx;
              }
            });
            if (idx_tag > 3) {
              this.isTagActive = false;
            }
          } else if (text == "more") {
            this.listTag.forEach((element, idx) => {
              if (element._id == this.TagId) {
                item_tag = element;
                idx_tag = idx;
              }
            });
            if (idx_tag > 3) {
              this.isTagActive = item_tag._id;
            }
          }
          this.tag.limit_by =
            this.tag.limit_by === this.tag.default_limit
              ? 10
              : this.tag.default_limit;
          this.isMenuActive = false;
          this.isGradeActive = false;
          this.isTutorActive = false;
          this.isCatgActive = false;
          break;
        default:
          this.category.limit_by = this.category.default_limit;
          this.grade.limit_by = this.grade.default_limit;
          this.tutor.limit_by = this.tutor.default_limit;
          this.tag.limit_by = this.tag.default_limit;
          break;
      }
    },
    onSearch() {
      if (this.mainSearch != "" && this.mainSearch != undefined) {
        let q = this.mainSearch;
        this.mobileSearch = false;
        // this.mainSearch = "";
        if (this.$route.name == "search") {
          this.$router.push({
            query: {
              q: q,
            },
          });
          EventBus.$emit("onSearchReload", q);
        } else {
          this.$router.push({
            name: "search",
            query: {
              q: q,
            },
          });
        }
      }
    },
    async getProfile() {
      const info = Vue.prototype.$userInfo;
      //const elements = await Vue.prototype.$elements;

      // let category = elements.filter(
      //   (item) => item.template == "category_horizontal_listview"
      // );

      // let tag = elements.filter((item) => item.template == "tag_list");
      // let tutor = elements.filter(
      //   (item) => item.template == "teacher_horizontal_listview"
      // );

      // this.elements.category = category[0];
      // this.elements.tag = tag[0];
      // this.elements.instructor = tutor[0];

      // console.log(this.elements);

      if (info != null) {
        // console.log(info.companies)
        // this.logo = info.companies[0].logo;
        this.logo = info.companies[0].coverImg;
        this.title = info.companies[0].title;
        this.contact = info.companies[0].contactEmail;
        this.displayName = info.displayName;
        this.avatar = info.image;
        this.themeColor = info.companies[0].themeColor;
      }
      if (this.$vuetify.breakpoint.lgAndUp) {
        this.drawer = true;
      }
      const theme = localStorage.getItem("theme");
      if (theme != null) {
        this.$vuetify.theme.themes.light.primary = theme;
      }
    },
    navigate(mode, item) {
      switch (mode) {
        case "category":
          this.isMenu = "";
          this.isMenuActive = false;
          this.isGradeActive = false;
          this.isTagActive = false;
          this.isTutorActive = false;
          this.$router.push({
            name: "course",
            query: {
              category: item._id,
              page: 1,
              limit: 9,
              sort: "created_at",
              sortby: 1,
              title: item.title,
            },
            params: {
              title: item.title,
            },
          });
          break;
        case "grade":
          this.isMenu = "";
          this.isMenuActive = false;
          this.isCatgActive = false;
          this.isTagActive = false;
          this.isTutorActive = false;
          this.$router.push({
            name: "course",
            query: {
              grade: item._id,
              page: 1,
              limit: 10,
              sort: "created_at",
              sortBy: -1,
            },
          });
          break;
        case "tag":
          this.isMenu = "";
          this.isMenuActive = false;
          this.isCatgActive = false;
          this.isGradeActive = false;
          this.isTutorActive = false;
          this.$router.push({
            name: "course",
            query: {
              skill: item._id,
              page: 1,
              limit: 9,
              sort: "created_at",
              sortby: 1,
              title: item.title,
            },
            params: {
              title: item.title,
            },
          });
          break;
        case "tutor":
          this.isMenu = "";
          this.isMenuActive = false;
          this.isCatgActive = false;
          this.isGradeActive = false;
          this.isTagActive = false;
          this.$router.push({
            name: "instructor",
            query: {
              sort: "created_at",
              sortby: 1,
              limit: 9,
              page: 1,
            },
            params: {
              id: item._id,
            },
          });
          break;
        case "menu":
          this.isCatgActive = false;
          this.isGradeActive = false;
          this.isTagActive = false;
          this.isTutorActive = false;
          // console.log(item.type);

          if (item.type == "overview") {
            this.$router.push({
              path: "/home",
            });
          } else if (item.type == "mycourse") {
            this.$router.push({
              path: "/mycourse",
            });
          } else if (item.type == "search") {
            const input = document.getElementById("searchId");
            input.focus();
            // input.setSelectionRange(2, 5);
            let to = this.$route;
            console.log(to);
            if (to.name == "search") {
              if (to.query.q) {
                this.$router.push({
                  name: "search",
                  query: {
                    q: to.query.q,
                  },
                });
              } else {
                this.$router.push({
                  path: "/search",
                });
              }
            } else {
              this.$router.push({
                path: "/search",
              });
            }
          } else if (item.type == "setting") {
            this.$router.push({
              path: "/profile",
            });
          } else if (item.type == "notification") {
            this.$router.push({
              path: "/notification",
            });
          } else {
            this.$router.push({
              path: "/home",
            });
          }

          break;
        case "home":
          this.isCatgActive = false;
          this.isGradeActive = false;
          this.isTagActive = false;
          this.isTutorActive = false;
          this.$router.push({
            path: "/home",
          });
          break;
        case "mycourse":
          this.isCatgActive = false;
          this.isGradeActive = false;
          this.isTagActive = false;
          this.isTutorActive = false;
          this.$router.push({
            name: "my_course",
          });
          break;
        case "profile":
          this.isCatgActive = false;
          this.isGradeActive = false;
          this.isTagActive = false;
          this.isTutorActive = false;
          this.$router.push({
            name: "profile",
          });
          break;
        case "favorite":
          this.isCatgActive = false;
          this.isGradeActive = false;
          this.isTagActive = false;
          this.isTutorActive = false;
          this.$router.push({
            name: "wishlist",
          });
          break;
        case "search":
          this.isCatgActive = false;
          this.isGradeActive = false;
          this.isTagActive = false;
          this.isTutorActive = false;
          this.$router.push({
            name: "search",
          });
          const input = document.getElementById("searchId");
          input.focus();
          break;
        default:
          this.$router.push({
            path: "/home",
          });
          break;
      }
    },
    more_tutor() {
      this.isMenu = "";
      this.isMenuActive = false;
      this.isGradeActive = false;
      this.isTagActive = false;
      this.isCatgActive = false;
      this.isTutorActive = false;
      let qs = {
        page: 1,
        limit: 10,
        sort: "displayName",
        sortby: 1,
        title: "Instructor",
      };
      this.$router.push({
        name: "instructors",
        query: qs,
      });
    },
    logout() {
      EventBus.$emit("signout");
    },
    checkActiveCategory(catg) {
      this.isMenu = "";
      this.isMenuActive = false;
      this.isGradeActive = false;
      this.isTagActive = false;
      this.isTutorActive = false;
      const index = this.listCategory.findIndex((element) => {
        if (element._id == catg) {
          return true;
        }
      });
      if (index > 3 && this.category.limit_by == 4) {
        this.simpleToggleShowMore("category", this.listCategory.length);
      }
      this.isCatgActive = catg;
    },
    checkActiveTag(tag) {
      this.isMenu = "";
      this.isMenuActive = false;
      this.isGradeActive = false;
      this.isCatgActive = false;
      this.isTutorActive = false;
      const index = this.listTag.findIndex((element) => {
        if (element._id == tag) {
          return true;
        }
      });
      if (index > 3 && this.tag.limit_by == 4) {
        this.simpleToggleShowMore("tag", this.listTag.length);
      }
      this.isTagActive = tag;
    },
    checkActiveTutor(tutor) {
      let index = this.listTutor.findIndex((element) => {
        if (element._id == tutor) {
          return true;
        }
      });
      if (index > 3) {
        this.isTutorActive = false;
      } else {
        this.isTutorActive = tutor;
      }
    },
    openAssessment(courseId, skipReport = false) {
      // console.log("Yes");
      //#region generate data
      // 6037a3cd681ca725e591524e

      let data = {
        numStamp: `${Vue.prototype.$userInfo._id}${Date.now()}`,
        token: this.$cookies.get("user_token"),
        course: courseId,
        skipReport: skipReport,
      };
      let url = environment.assessmentDomain;
      //#endregion

      //#region encrypt data
      let jsonData = JSON.stringify(data);
      let secret = "kJYSb2aTHqa3JBGV";
      let encrypted = CryptoJS.AES.encrypt(jsonData, secret);
      let sessionData = encrypted.toString();
      let sessionData_encodeURI = encodeURIComponent(sessionData);
      //#endregion

      window.open(`${url}?session=${sessionData_encodeURI}`, "_blank");
    },
  },
  watch: {
    $route(to) {
      console.log(to);
      console.log(to.name);
      this.CatgId = to.query.category;
      this.TagId = to.query.skill;
      if (to.name == "instructor" && to.params.isHorizental) {
        this.checkActiveTutor(to.params.id);
      }
      if (to.name == "course" && to.query.category && to.params.isHorizental) {
        this.checkActiveCategory(to.query.category);
      }
      if (to.name == "search") {
        console.log(to.query.q);
        this.isMenu = "search";
        this.isMenuActive = true;
        if (to.query.q) {
          this.mainSearch = to.query.q;
          console.log(this.mainSearch);
        } else {
          this.mainSearch = "";
        }
      } else {
        this.mainSearch = "";
      }
    },
  },
  beforeDestroy() {
    EventBus.$off("evalIdentity");
    EventBus.$off("configPaymentResult");
  },
  async mounted() {
    EventBus.$on("configPaymentResult", (result) => {
      console.log("payment available", result);
    });
    EventBus.$on("evalIdentity", (courseId, skipReport = false) => {
      this.openAssessment(courseId, skipReport);
    });
    await this.getProfile();
    await this.getCategoryList();
    await this.getTagList();
    await this.getTutorList();
    let to = this.$route;
    if (to.name == "search") {
      this.isMenu = "search";
      this.isMenuActive = true;
      const input = document.getElementById("searchId");
      input.focus();
      if (to.query.q) {
        this.mainSearch = to.query.q;
      }
    }

    switch (this.$route.meta.type) {
      case "mycourse":
        this.isMenu = this.$route.meta.type;
        break;
      case "setting":
        this.isMenu = this.$route.meta.type;
        break;
      case "overview":
        this.isMenu = this.$route.meta.type;
        break;
      case "search":
        this.isMenu = this.$route.meta.type;
      case "instructor":
        this.isTutorActive = this.$route.params.id;
        break;
      case "course":
        if (this.$route.query.category) {
          await this.checkActiveCategory(this.$route.query.category);
        } else {
          await this.checkActiveTag(this.$route.query.skill);
        }
        break;
    }

    // call config payment
    EventBus.$emit("configPayment");
  },
  updated() {
    let search = this.$route.query.search || null;
    if (search != null) {
      this.mainSearch = search;
    }
  },
  computed: {
    isClassRoom() {
      let isClassRoom = this.$route.meta.isClassRoom || null;
      if (isClassRoom) {
        return "main container";
      }
      return "";
    },
    // isCategoryId() {
    //   return Vue.prototype.$categoryId;
    // },
    canRegister() {
      return Vue.prototype.$userInfo.companies[0].canRegister;
    },
  },
};
</script>

<style scoped>
.theme--light.v-navigation-drawer {
  background-color: #fafafa;
}
.mainNavigator {
  background-color: #fafafa;
  font-size: 16px;
  font-weight: 500;
  color: #808080;
}

.navigatorDiv {
  padding: 10px 10px 10px 10px;
}

.oneLineDiv {
  display: flex;
}
.title-tag {
  font-size: 16px;
  color: #808080;
}
.navigator-item {
  font-size: 16px;
  color: #808080;
  /* margin: auto;
  margin-left: 20px; */
}

.navigatorTitle {
  font-size: 18px;
  font-weight: bold;
  color: #4a4a4a;
  margin-left: 12px;
}

.layoutHeader {
  font-size: 24px;
  font-weight: bold;
  color: #4a4a4a;
}

.Oval {
  width: 6px;
  height: 6px;
  margin: 8px 0px 0px 0px;
  background-color: #cfcfcf;
}

.searchBox {
  width: 100%;
  max-width: 800px;
  background-color: #f2f2f2;
}

.v-application--is-ltr .v-list-item__action:first-child,
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 20px;
}
</style>

<style lang="scss">
.searchBox {
  .v-icon.v-icon {
    font-size: 18px;
    color: #c5c5c5;
  }
  &.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
    > .v-input__control
    > .v-input__slot
    fieldset {
    color: #f2f2f2;
  }
}

.v-navigation-drawer__content {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden !important;

  &::-webkit-scrollbar {
    width: 0px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c5c5c5;
    border-radius: 20px;
  }
}
@import "../scss/variables.scss";
</style>
